<template>
  <span class="time-since">
    {{ time }}
  </span>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'TimeSince',

  props: {
    date: {
      type: Date as PropType<Date>,
      required: true,
    },
  },

  computed: {
    time(): string {
      const seconds = this.getDiffInSeconds(this.date);

      if (seconds < 60) return this.$t('durationAgo.fewSeconds');

      const minutes = seconds / 60;

      if (minutes < 60)
        return this.$t('durationAgo.minutes', Math.floor(minutes), {
          named: {
            duration: Math.floor(minutes),
          },
        });

      const hours = minutes / 60;

      if (hours < 24)
        return this.$t('durationAgo.hours', Math.floor(hours), {
          named: {
            duration: Math.floor(hours),
          },
        });

      const days = hours / 24;

      if (days < 5)
        return this.$t('durationAgo.days', Math.floor(days), {
          named: {
            duration: Math.floor(days),
          },
        });

      return this.$d(this.date, 'short');
    },
  },

  methods: {
    getDiffInSeconds(startDate: Date) {
      const endDate = new Date();

      return (endDate.getTime() - startDate.getTime()) / 1000;
    },
  },
});
</script>
